/*
 Copyright 2024 BFB Labs

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

	  https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

import React from 'react';
import './InitialFormLandingComponent.css'
import { Button } from '@mui/material';
 
const InitialFormLandingComponent = ({startForm}) => {
	 
	return(
		<div className='dis-flex justify-space-around'>
			<div className='dis-flex flex-column flex-grow-3'></div>
			<div className='dis-flex flex-column flex-grow-4 form-component'>
				<div className='dis-flex flex-row'>
					<div className='text-bold font-20'>
						Welcome to Lumi Nova: Tales of Courage - a therapeutic mobile game to help your child overcome their worries in a fun way!
					</div>
				</div>
				<div className='dis-flex flex-row font-20 m-t-10'>
					<div >
						You are just 1 step away from getting your game key.
					</div>
				</div>
				<div className='form-seperator'></div>
				<div className='dis-flex'>
					<Button style={{background:'var(--theme-blue)', padding: '10px 50px'}} variant='contained' onClick={startForm} fullWidth={false}><b>START</b></Button>
				</div>
			</div>
			<div className='dis-flex flex-column flex-grow-3'></div>
		</div>
	)
 
}
 
export default InitialFormLandingComponent;